// import { SnackBarComponent } from '../../../components/snack-bar/snack-bar.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { AuthService } from 'src/app/data/services/auth.service';
import { CustomSnackbarService } from 'src/app/ui/components/custom-snackbar/custom-snackbar-service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  loading: boolean = false;
  hasErrors: boolean = false;
  error403Message =
    'Você não pode realizar esta ação. Entre em contato com a instituição.';

  fgForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private snackbarService: CustomSnackbarService,
    private readonly authService: AuthService
  ) {}

  ngOnInit() {}

  async onSubmit() {
    this.loading = true;
    this.hasErrors = false;

    const email = this.fgForm.value.email;

    try {
      await this.authService.forgotPassword(email).toPromise();
      this.loading = false;
      this.snackbarService.open(
        'Código enviado com sucesso',
        SnackbarTypeEnum.SUCCESS,
        'center',
        'bottom'
      );
      this.router.navigate(['reset-password', email], {
        skipLocationChange: true,
      });
    } catch (error: any) {
      this.loading = false;
      if (error?.status === 403) {
        this.hasErrors = true;
      } else {
        this.snackbarService.open(
          'E-mail inválido ou não encontrado',
          SnackbarTypeEnum.WARNING,
          'center',
          'bottom'
        );
      }
    }
  }
}
